import { CountryCode } from '../../index.js';
import { DKTribunalCaseType } from './countries/denmark.js';
import { GLTribunalCaseType } from './countries/greenland.js';
export const TribunalCaseType = {
    ...DKTribunalCaseType,
    ...GLTribunalCaseType,
};
export var TribunalCaseStatus;
(function (TribunalCaseStatus) {
    TribunalCaseStatus["Created"] = "CREATED";
    TribunalCaseStatus["Closed"] = "CLOSED";
    TribunalCaseStatus["Awaiting1Paategning"] = "AWAITING1PAATEGNING";
    TribunalCaseStatus["Awaiting2Paategning"] = "AWAITING2PAATEGNING";
    TribunalCaseStatus["AwaitingNoticeForBailiffMeeting"] = "AWAITINGNOTICEFORBAILIFFMEETING";
    TribunalCaseStatus["AwaitingBailiffMeeting"] = "AWAITINGBAILIFFMEETING";
    TribunalCaseStatus["ClosedBecauseOfObjection"] = "CLOSEDBECAUSEOFOBJECTION";
    TribunalCaseStatus["AwaitingVerdict"] = "AWAITINGVERDICT";
    TribunalCaseStatus["AwaitingNoticeForFogedmoede"] = "AWAITINGNOTICEFORFOGEDMOEDE";
    TribunalCaseStatus["AwaitingFogedmoede"] = "AWAITINGFOGEDMOEDE";
})(TribunalCaseStatus || (TribunalCaseStatus = {}));
export const tribunalCaseTypesByCountry = {
    [CountryCode.DK]: DKTribunalCaseType,
    [CountryCode.GL]: {
        ...GLTribunalCaseType,
        ...DKTribunalCaseType,
    },
};
//# sourceMappingURL=types.js.map